import React, { useEffect, useState } from "react";
import {
  DialogContent,
  DialogTitle,
  Dialog,
  Tooltip,
  Box,
  Button,
  CircularProgress,
} from "@material-ui/core";
import DataTable from "./DataTable";

const ConnectedDevices = ({
  device_serial,
  connectedDevices,
  loading,
  getConnectedDevices,
}) => {
  const [open, setOpen] = useState(false);
  const [pageSize, setPageSize] = useState(20);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setPageSize(20);
  };

  useEffect(() => {
    if (connectedDevices !== null) setOpen(true);
  }, [connectedDevices]);

  const columns = [
    {
      field: "device",
      headerName: "Device",
      filterable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "mac_address",
      headerName: "MAC Address",
      filterable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "ip_address",
      headerName: "IP Address",
      filterable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "ssid",
      headerName: "Network",
      filterable: false,
      sortable: false,
      flex: 1,
    },
  ];

  return (
    <>
      <Tooltip title="See Connected Devices">
        <Button
          style={{ cursor: "pointer", marginLeft: "5px", padding: 4 }}
          onClick={() =>
            connectedDevices ? handleClickOpen() : getConnectedDevices()
          }
          variant="contained"
          disabled={loading}
        >
          {loading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            "See Devices"
          )}
        </Button>
      </Tooltip>
      <Dialog
        onClose={handleClose}
        open={open}
        aria-labelledby="simple-dialog-title"
        fullWidth={true}
        maxWidth={"lg"}
      >
        <DialogTitle id="simple-dialog-title">
          {device_serial} Connected Devices
        </DialogTitle>
        <DialogContent>
          <Box sx={{ height: 400, width: "100%" }}>
            <DataTable
              columns={columns}
              data={connectedDevices}
              loading={loading}
              paginationMode="client"
              getRowId={(row) => row.mac_address}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ConnectedDevices;
